module.exports = __webpack_public_path__ + "static/media/herobg.f64ec132.png";